export default __webpack_public_path__ + "static/media/laker.5e92eb8e.png";